import { SaleDetailModel } from 'api-hooks/sale/model';
import * as React from 'react';

import CruiseRescheduleForm from './form';

interface Props {
  cruiseSale: SaleDetailModel;
}

export default function CruiseReschedule(props: Props) {
  const { cruiseSale } = props;
  return <CruiseRescheduleForm {...props} cruiseSale={cruiseSale} />;
}
